import { FloatingButtonWrapper } from "./Wrappers";

export const FloatingStatusButton = ({ label }) => {
  return <FloatingButtonWrapper>{label}</FloatingButtonWrapper>;
};
